import React from "react";
import "./index.css"; 

const steps = ["Pre-Checkout", "Checkout", "Payment"];

const CheckoutBreadcrumb = ({ currentStep }) => {
    return (
        <div className="breadcrumb-container">
            {steps.map((step, index) => (
                <div key={index} className="breadcrumb-item">
                    <div className={`breadcrumb-circle ${index <= currentStep ? "active" : ""}`}>
                        {index + 1}
                    </div>
                    <p className={`breadcrumb-text ${index <= currentStep ? "active-text" : ""}`}>
                        {step}
                    </p>
                    {index < steps.length - 1 && <div className={`breadcrumb-line ${index < currentStep ? "active-line" : ""}`}></div>}
                </div>
            ))}
        </div>
    );
};

export default CheckoutBreadcrumb;
